import { Link } from 'react-router-dom';
import { useI18n } from '@/contexts/I18nContext';
import { pickByLang } from '@/i18n';

export default function HomeFooter() {
  const { t, localePath, lang } = useI18n();
  const sitemapLabel = pickByLang({
    ko: '사이트맵',
    ja: 'サイトマップ',
    th: 'แผนผังเว็บไซต์',
    vi: 'Sơ đồ trang',
    id: 'Peta Situs',
    en: 'Sitemap',
    ms: 'Peta Laman',
    my: 'ဆိုက်မြေပုံ',
    'pt-BR': 'Mapa do site',
    de: 'Sitemap',
    es: 'Mapa del sitio',
    fr: 'Plan du site',
    ar: 'خريطة الموقع',
    'zh-TW': '網站地圖',
    'zh-CN': '网站地图',
  }, lang);

  return (
    <footer className="border-t border-border py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8 text-sm">
          <div>
            <h3 className="font-semibold text-foreground mb-3">{t.footerMockTest}</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to={localePath('/practice/rounds')} className="hover:text-foreground transition-colors">{t.mockTestHubAllRounds}</Link></li>
              <li><Link to={localePath('/questions')} className="hover:text-foreground transition-colors">{t.footerQuestionPool}</Link></li>
              <li><Link to={localePath('/questions/speaking')} className="hover:text-foreground transition-colors">{t.footerSpeaking}</Link></li>
              <li><Link to={localePath('/questions/writing')} className="hover:text-foreground transition-colors">{t.footerWriting}</Link></li>
              <li><Link to={localePath('/questions/cat')} className="hover:text-foreground transition-colors">{t.catLabel}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3">{t.footerStudy}</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to={localePath('/grammar')} className="hover:text-foreground transition-colors">{t.navGrammar}</Link></li>
              <li><Link to={localePath('/vocabulary')} className="hover:text-foreground transition-colors">{t.navVocabulary}</Link></li>
              <li><Link to={localePath('/score-chart')} className="hover:text-foreground transition-colors">{t.scoreChartLabel}</Link></li>
              <li><Link to={localePath('/books')} className="hover:text-foreground transition-colors">{t.footerBooks}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3">{t.navTips}</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to={localePath('/tips/listening')} className="hover:text-foreground transition-colors">{t.footerLCStrategy}</Link></li>
              <li><Link to={localePath('/tips/reading')} className="hover:text-foreground transition-colors">{t.footerRCStrategy}</Link></li>
              <li><Link to={localePath('/tips/7-day-plan')} className="hover:text-foreground transition-colors">{t.footer7DayPlan}</Link></li>
              <li><Link to={localePath('/tips/trap-patterns')} className="hover:text-foreground transition-colors">{t.footerTrapPatterns}</Link></li>
              <li><Link to={localePath('/guide')} className="hover:text-foreground transition-colors font-medium">{t.footerGuide}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-3">{t.footerEtc}</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to={localePath('/pricing')} className="hover:text-foreground transition-colors text-accent font-semibold">{t.navPremium}</Link></li>
              <li><Link to={localePath('/faq')} className="hover:text-foreground transition-colors">{t.navFAQ}</Link></li>
              <li><Link to={localePath('/privacy')} className="hover:text-foreground transition-colors">{t.footerPrivacy}</Link></li>
              <li><Link to={localePath('/terms')} className="hover:text-foreground transition-colors">{t.footerTerms}</Link></li>
              <li><Link to={localePath('/refund')} className="hover:text-foreground transition-colors">{t.footerRefund}</Link></li>
              <li><Link to={localePath('/about')} className="hover:text-foreground transition-colors">{t.footerAbout}</Link></li>
              <li><Link to={localePath('/contact')} className="hover:text-foreground transition-colors">Contact</Link></li>
              <li><Link to={localePath('/sitemap')} className="hover:text-foreground transition-colors">{sitemapLabel}</Link></li>
            </ul>
          </div>
        </div>
        <div className="text-center text-xs text-muted-foreground border-t border-border pt-6 space-y-2">
          <p>{t.footerCopyright}</p>
          <p className="text-[11px] opacity-70">{t.footerDisclaimer}</p>
        </div>
      </div>
    </footer>
  );
}
